angular.module('common.directives.inlineEditText', [])

    .directive("inlineEditText", function ($animate, $timeout, $http, $compile) {
        return ({
            restrict: 'E',
            //scope: {}, // We need to share the scope here, so we update templates passed to directives and bind some elements 
                         // to directive's handlers/properties and some to parent scope's properties
            controller: 'inlineEditTextController',
            controllerAs: 'inlineEditTextController',
            link: function (scope, element, attrs, parentCtrl) {

                if (!element || !element[0]) return;

                var viewTemplateElement = element.find('view-template');
                var editTemplateElement = element.find('edit-template'); //If edit template is not found - we won't be rendering a button and click handler to switch into 'edit mode'

                if (viewTemplateElement.length === 0) {
                    return; //Do nothing as we don't have view template
                }

                if (editTemplateElement.length > 1) {
                    throw new Error('Edit template must contain single root element.');
                }

                var id = _.random(0, 1000000);
                var inlineEditFormName = `inlineEditForm${id}`;

                //Update view-template's and edit-template's internal elements where necessary
                var editInputElement = editTemplateElement.find('[ng-model]').first();
                if (editInputElement) {
                    editInputElement.attr('id', `editElementRoot${id}`);
                    editInputElement.attr('ng-keydown', `cancelOrSave($event, ${inlineEditFormName})`); //add so we can handle the keydown events during user edit actions
                    editInputElement.attr('ng-blur', `cancelOrSave($event, ${inlineEditFormName})`);    //add so we can handle event when user clicks away from edit control
                }

                var viewTemplate = viewTemplateElement.html();
                var editTemplate = editTemplateElement ? editTemplateElement.html() : null;

                //Now wrap the edit template supplied to the directive with additional form and container element markup
                editTemplate =
                    `<div ng-hide="!isEditMode(${id})" class="inline-edit-container">
                        <form name="${inlineEditFormName}" class="text-field-form validate" ng-model-options="{ updateOn: 'custom' }">
                            ${editTemplate}
                            <a href="" ng-click="save($event, ${inlineEditFormName})" title="{{'Save value'|translate}}" class="fa fa-check save-text-field-btn" />
                        </form>
                    </div>`;

                viewTemplate =
                    `<div ng-hide="isEditMode(${id})" class="text-field-container" ng-click="toEditMode('${id}')">
                        ${viewTemplate}
                        <a href="" ng-click="toEditMode('${id}')" title="{{'Edit value'|translate}}" class="fa fa-pencil edit-text-field-btn" />
                    </div>`;

                //Finally assemble container element to hold view and edit parts of UI
                var inlineEditContainerElementTemplate = `<div class="inline-edit-text">${viewTemplate}\n${editTemplate}</div>`;
                var inlineEditContainerElement = $compile(inlineEditContainerElementTemplate)(scope); //compile against directive's scope, which inherits all the properties from parent scope

                //Finally replace our directive original element with re-compiled and actual content
                element.replaceWith(inlineEditContainerElement);
            }
        });
    })
    .controller('inlineEditTextController', function ($element, $scope, $http, $compile, $timeout) {

        //We need the hashmap of the edit flags for all inline edit controls as they don't have isolated scope, but share scope instead with parent scope
        //This is necessary in order to be able to wrap the edit controls into UI blocks using the bindings to parent scope, yet being able to bind to some
        //of our handlers as well. We can't bind one control simultaneously to more than one scope.
        var editFlagsMap = new Map();

        _.extend($scope, {
            getEditMode: getEditMode,
            setEditMode: setEditMode,
            isEditMode: isEditMode,
            save: save,
            cancelOrSave: cancelOrSave,
            toEditMode: toEditMode
        });

        init();

        function init() {
            //We need the hashmap of the original values for all inline edit controls as they don't have isolated scope, but share scope instead with parent scope
            $scope.originalValues = new Map();
        }

        function getEditMode(uid) {
            return editFlagsMap.get(uid.toString());
        }
        function setEditMode(uid, value) {
            editFlagsMap.set(uid.toString(), value);
        }

        function isEditMode(uid) {
            return $scope.getEditMode(uid) === true;
        }

        function save(e, form) {
            if (form) {
                if (!e || !e.target) return;

                //Get original value stored to compare with the value entered by user to see if we need to actually commit anything
                var originalValue = $scope.originalValues.get(e.target.id);

                //We need  to enforce the form validation and proceed only if the form is valid
                //The form is not validated yet as we use the 'custom' value for 'updateOn' ng-model-option configuration setting
                //so the value is not propagated onto the model unless we explicitly save the value to the server by clicking 'save' button
                //or by User's pressing 'Enter' key
                if ((e.target.required && (!e.target.value || e.target.value === '')) || e.target.value === originalValue) {
                    revertChangeAndCancelEdit(e, form);
                    return;
                }

                if (e.target.pattern) {
                    try {
                        const re = new RegExp(e.target.pattern);
                        if (!re.test(e.target.value)) {
                            revertChangeAndCancelEdit(e, form);
                            return;
                        }
                    } catch (e) {
                    }
                }

                //Commit the value from the form to ng-model if we have the form.
                //This is necessary cause we have 'custom' ng-model-options to update model value 
                //so we don't save new value entered if user decides not to save it and clicked away
                form.$commitViewValue();
            }

            $scope.$applyAsync(function () {
                setEditMode(getId(form), false);
                setIsBusyOnParentScope(true);
            });
        }

        function setIsBusyOnParentScope(valueToSet) {
            if ($scope.$parent && $scope.$parent.$parent) {
                $scope.$parent.$parent.isBusy = valueToSet;
            }
        }

        function toEditMode(uid) {
            var selector = `#editElementRoot${uid}`;

            setEditMode(uid, true);

            $timeout(function () {
                $scope.$applyAsync(function () {
                    if (selector && selector.length > 0) {
                        var input = $(selector);
                        if (input.length > 0) {
                            input.focus();

                            $scope.originalValues.set(input[0].id, input.val());
                        }
                    }
                });
            });
        }

        function cancelOrSave(e, form) {

            if (e) {
                //Keypress
                if (e.keyCode) {
                    if (e.keyCode === 27) {
                        //Esc pressed, so cancel edit
                        revertChangeAndCancelEdit(e, form);
                    }
                    if (e.keyCode === 13) {
                        //Enter pressed
                        save(e, form);
                    }
                } else {
                    if (e.relatedTarget && $(e.relatedTarget).hasClass('save-text-field-btn')) {
                        //User wants to save new value by clicking on Save button
                        save(e, form);
                    } else if (e.type === 'blur') {
                        revertChangeAndCancelEdit(e, form);
                    }
                }

            }
        }

        function revertChangeAndCancelEdit(e, f) {
            //e.preventDefault(); //We need this to not save the value onto model when we have 'blur' cause model value configured to be updated on blur only
            //This is necessary to avoid value saving onto model when user just clicks away
            if (f) {
                f.$rollbackViewValue();
                f.$setPristine();
                f.$setUntouched();
            }
            setEditMode(getId(f), false);
        }

        function getId(element) {
            if (element && element.$name) {
                return element.$name.replace('inlineEditForm', '');
            }

            return null;
        }

    });
